import { IntercomAPI } from 'react-intercom';

export function openIntercomChat() {
  if (!window._env_.INTERCOM_ACTIVE || !IntercomAPI) {
    console.log('Intercom is not active!');

    return;
  }

  IntercomAPI('show');
}
